<template>
  <router-view />
</template>

<script setup>
// No imports needed; router-view is globally available
</script>
